import * as Yup from 'yup';
import { ParamWithNestedParent } from '../../../../../../shared/types/param';

export const initialValues: ParamWithNestedParent = {
    name: '',
    active: true,
    code: '',
    class: '',
    extra2: '',
    parent: '',
    nestedParent: '',
};

export const validationSchema = (id: string) =>
    Yup.object({
        name: Yup.string().required('El nombre es obligatorio'),
        parent: Yup.string().required('El medio es obligatorio'),
        nestedParent: Yup.string().required('El tipo PQR es obligatorio'),
        extra2: id
            ? Yup.string().required('El descripción es obligatoria')
            : Yup.string().notRequired(),
    });
